<template>
  <WebsiteLayout>
    <div class="app-container hero discover">
      <div class="main-app-wrapper dashboard discover">
        <div class="div-block-56">
          <div class="div-block-255">
            <div class="div-block-57">
              <div
                class="text-block-49 skeleton-load"
                style="width:200px;"
                v-if="loader.nonBlockingLoader"
              ></div>
              <div class="text-block-49" v-else>
                {{ groupSession.groupSessionTopic }}
              </div>
            </div>
            <div class="class-action-btn-container">
              <div>
                <div
                  class="button w-button skeleton-load"
                  style="width:150px;"
                  v-if="loader.nonBlockingLoader"
                ></div>
                <div
                  v-else
                  class="button-4 hide w-button"
                  @click="openShareClassModal"
                >
                  Share class
                </div>
              </div>
              <div v-if="userCanJoinClass()">
                <div
                  class="button w-button skeleton-load"
                  style="width:150px;"
                  v-if="loader.nonBlockingLoader"
                ></div>
                <div
                  v-else
                  class="button w-button"
                  style="height: 50px;
  font-family: 'Galano grotesque-Regular', sans-serif;
  font-size: 14px;"
                  @click="openClassModal"
                >
                  Join class
                </div>
              </div>
            </div>
          </div>
          <div
            class="card-content-header more"
            style="display: flex;
          justify-content: flex-start;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 0;"
          >
            <div
              class="date-block skeleton-load"
              style="width:100px;"
              v-if="loader.nonBlockingLoader"
            ></div>
            <div class="date-block" v-else>
              <img
                loading="lazy"
                src="@/assets/timeslot-images/calendar1.svg"
                alt=""
              />
              <div class="date-tect">
                {{
                  new Date(groupSession.groupSessionStartTime.slice(0, 10))
                    .toString()
                    .slice(0, 11)
                }}
              </div>
            </div>
            <div
              class="time-block skeleton-load"
              style="width:100px;"
              v-if="loader.nonBlockingLoader"
            ></div>
            <div class="time-block" v-else>
              <img
                loading="lazy"
                src="@/assets/timeslot-images/clock1.svg"
                alt=""
              />
              <div class="time-range">
                {{
                  formatHours(new Date(groupSession.groupSessionStartTime))
                }}:{{
                  formatMinutes(new Date(groupSession.groupSessionStartTime))
                }}
                {{ formatTime(new Date(groupSession.groupSessionStartTime)) }}
                -
                {{ formatHours(new Date(groupSession.groupSessionEndTime)) }}:{{
                  formatMinutes(new Date(groupSession.groupSessionEndTime))
                }}
                {{ formatTime(new Date(groupSession.groupSessionEndTime)) }}
              </div>
            </div>
          </div>
          <div class="w-row">
            <div class="column w-col w-col-6">
              <div
                class="div-block-250 skeleton-load"
                v-if="loader.nonBlockingLoader"
              ></div>
              <div
                class="div-block-250"
                v-else
                :class="
                  groupSession.groupSessionId === 42
                    ? 'div-block-250-alt'
                    : 'div-block-250'
                "
              >
                <div
                  class="text-block-112"
                  v-if="groupSession.groupSessionId !== 42"
                >
                  {{ groupSession.professionalName }}
                </div>
                <div
                  class="card-header-class"
                  v-if="groupSession.groupSessionId !== 42"
                >
                  {{ groupSession.groupSessionTopic }}
                </div>
                <img
                  src="@/assets/timeslot-images/img.png"
                  v-if="groupSession.groupSessionId === 42"
                  width="100%"
                  height="350px"
                />
              </div>
            </div>
            <div class="w-col w-col-6">
              <div class="div-block-248">
                <div class="div-block-251">
                  <div class="div-block-253">
                    <h1
                      v-if="loader.nonBlockingLoader"
                      class="heading-27 skeleton-load"
                      style="width:150px;"
                    ></h1>
                    <h1 v-else class="heading-27">Description</h1>
                    <div
                      v-if="loader.nonBlockingLoader"
                      style="font-size: 14px;"
                    ></div>
                    <div v-else style="font-size: 14px;">
                      {{ groupSession.groupSessionDescription }}
                    </div>
                    <h1
                      v-if="loader.nonBlockingLoader"
                      class="heading-27 skeleton-load"
                      style="width:150px;"
                    ></h1>
                    <h1 v-else class="heading-27">Amount</h1>
                    <div
                      v-if="loader.nonBlockingLoader"
                      style="font-size: 14px;"
                    ></div>
                    <div v-else style="font-size: 14px;">
                      ${{ groupSession.groupSessionAmount }}
                    </div>
                    <h1
                      v-if="loader.nonBlockingLoader"
                      class="heading-27 skeleton-load"
                      style="width:150px;"
                    ></h1>
                    <h1 v-else class="heading-27">Instructor</h1>
                    <div
                      v-if="loader.nonBlockingLoader"
                      class="div-block-252"
                    ></div>
                    <div
                      v-else
                      class="div-block-252"
                      @click="
                        goToProfProfile(groupSession.groupSessionProfessionalId)
                      "
                    >
                      <div>
                        <div class="prof-content">
                          <div class="prof-image-block">
                            <img
                              width="60"
                              height="60"
                              style="border-radius: 50%;"
                              loading="lazy"
                              :src="groupSession.professionalDisplayPicture"
                              alt=""
                            />
                          </div>
                          <div>
                            <div class="prof-name">
                              {{ groupSession.professionalName }}
                            </div>
                            <div class="prof-title">
                              {{ groupSession.professionalCategory }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="div-block-252"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="div-block-258"
            :style="[
              groupSession.groupSessionId === 42
                ? { 'margin-top': '70px' }
                : { 'margin-top': '0' }
            ]"
          >
            <h1
              v-if="loader.nonBlockingLoader"
              class="heading-27 skeleton-load"
              style="width:150px;"
            ></h1>
            <h1 v-else class="heading-27">Participants</h1>
            <h1 v-if="loader.nonBlockingLoader" style="width:150px;"></h1>
            <h1 v-else class="supporting_text">
              {{ groupSession.groupSessionCurrentAttendees }}/{{
                groupSession.groupSessionMaxAttendance
              }}
              attending
            </h1>
          </div>
          <div
            class="div-block-257"
            v-if="enrolledCustomers.length > 0 && userCanSeeEmailAddress()"
          >
            <div
              class="attendance skeleton-load"
              v-if="loader.nonBlockingLoader"
            ></div>
            <div v-else class="attendance">
              <div class="main_tale_header">
                <div class="table_header">
                  <div class="header_cell1">
                    <div class="header_cell">Name</div>
                  </div>
                  <!--                  <div class="header_cell1">-->
                  <!--                    <div class="header_cell">Phone Number</div>-->
                  <!--                  </div>-->
                  <div class="header_cell1">
                    <div class="header_cell">Country</div>
                  </div>
                  <div class="header_cell1" v-if="userCanSeeEmailAddress()">
                    <div class="header_cell">Email Address</div>
                  </div>
                </div>
              </div>
              <div
                v-if="enrolledCustomers.length > 0 && userCanSeeEmailAddress()"
              >
                <div
                  class="main_attendance_row"
                  v-for="(customer, index) in enrolledCustomers.slice(0, 8)"
                  :key="index"
                >
                  <router-link
                    :to="`/clients/${customer.groupSessionCustomerCustomerId}`"
                    class="attendance_row w-inline-block"
                  >
                    <div class="name_cell">
                      <img
                        :src="customer.customerDisplayPicture"
                        class="table-image-icon"
                        loading="lazy"
                        alt=""
                      />
                      <div class="name_text">{{ customer.customerName }}</div>
                    </div>
                    <!--                    <div class="name_cell">-->
                    <!--                      <div class="cell_text">-->
                    <!--                        {{ customer.customerPhoneNumber }}-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                    <div class="name_cell">
                      <div class="cell_text">
                        {{ customer.customerCountry }}
                      </div>
                    </div>
                    <div
                      class="name_cell cell-text-small"
                      v-if="userCanSeeEmailAddress()"
                      :title="customer.customerEmail"
                    >
                      <div class="cell_text ">{{ customer.customerEmail }}</div>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="main_attendance_row" v-else>
                <div
                  style="display:flex; justify-content: center; margin-top:30px;"
                >
                  <p
                    style="font-weight: 500; font-family: 'Galano grotesque-Medium', sans-serif"
                  >
                    No participants yet
                  </p>
                </div>
              </div>
            </div>
            <div
              class="pagination skeleton-load"
              v-if="loader.nonBlockingLoader"
            ></div>
            <div
              class="pagination"
              v-if="enrolledCustomers.length > 0 && !loader.nonBlockingLoader"
            >
              <a
                href="#"
                v-if="enrolledCustomers.length > 8"
                class="secondary_button w-button"
                >Previous</a
              >
              <div class="div-block-256" v-if="enrolledCustomers.length > 8">
                <div class="text-block-118">Page</div>
                <div>
                  <div class="text-block-119">1</div>
                </div>
                <div class="text-block-120">of</div>
                <div>
                  <div class="text-block-121">3</div>
                </div>
              </div>
              <a
                href="#"
                v-if="enrolledCustomers.length > 8"
                class="secondary_button w-button"
                >Next</a
              >
            </div>
          </div>
          <div
            v-if="enrolledCustomers.length === 0 && !loader.nonBlockingLoader"
          >
            <div
              style="display:flex; flex-direction:column; justify-content: center; align-items:center; margin-top:30px;"
            >
              <img
                src="@/assets/timeslot-images/myclass.svg"
                loading="lazy"
                alt=""
                class="image-6"
              />
              <p
                style="font-weight: 500; font-family: 'Galano grotesque-Medium', sans-serif"
              >
                No participants yet
              </p>
            </div>
          </div>
        </div>
      </div>
      <ClassDetailsModal
        v-if="classDetails"
        :prof-name="groupSession.professionalName"
        :cancel="closeClassModal"
      />
      <ShareClassModal
        v-if="shareClass"
        :cancel="closeShareClassModal"
        :link="generateClassLink"
      />
      <SignUpWarningModal
        :buttonAction="goToSignUp"
        v-if="signUpModal"
        :cancel="closeSignUpModal"
      />
    </div>
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import { mapState } from "vuex";
import moment from "moment";
import ClassDetailsModal from "@/components/modal/ClassDetailsModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import ShareClassModal from "@/components/modal/ShareClassModal";
import SignUpWarningModal from "@/components/modal/SignUpWarningModal";
export default {
  name: "ProfessionalClassDetails",
  components: {
    ShareClassModal,
    WebsiteLayout,
    ClassDetailsModal,
    SignUpWarningModal
  },
  data() {
    return {
      readModel: GroupSessionRequest.readByGroupSessionId,
      customerModel: GroupSessionRequest.readEnrolledClassCustomers,
      classDetails: false,
      shareClass: false,
      signUpModal: false
    };
  },
  computed: {
    ...mapState({
      groupSession: state => state.groupSession.singleGroupSession,
      enrolledCustomers: state => state.groupSession.enrolledCustomers,
      userInfo: state => state.auth.userInfo
    }),
    ...mapState(["loader"])
  },
  methods: {
    userCanJoinClass() {
      if (Object.keys(this.userInfo).length === 0) {
        return true;
      } else {
        if (
          this.enrolledCustomers.filter(
            item =>
              item.groupSessionCustomerCustomerId === this.userInfo.customerId
          ).length === 0
        ) {
          if ("professional" in this.userInfo) {
            if (
              this.groupSession.groupSessionProfessionalId ===
              this.userInfo.professional.professionalId
            ) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
    },
    userCanSeeEmailAddress() {
      if (Object.keys(this.userInfo).length === 0) {
        return false;
      } else {
        if ("professional" in this.userInfo) {
          if (
            this.groupSession.groupSessionProfessionalId ===
            this.userInfo.professional.professionalId
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }
    },
    openSignUpModal() {
      this.signUpModal = true;
    },
    closeSignUpModal() {
      this.signUpModal = false;
    },
    generateClassLink() {
      return `app.timeslate.com/class-details/${this.$route.params.id}`;
    },
    formattedDate(date) {
      return moment(date).format("LT");
    },
    formatDate(date) {
      return moment(date).format("ll");
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    },
    openClassModal() {
      if (!("token" in this.userInfo)) {
        this.openSignUpModal();
      } else {
        this.classDetails = true;
      }
    },
    closeClassModal() {
      this.classDetails = false;
    },
    goToProfProfile(value) {
      RouterUtils.changeRouteUrlTo(`/professionals/${value}`);
    },
    openShareClassModal() {
      this.shareClass = true;
    },
    closeShareClassModal() {
      this.shareClass = false;
    },
    goToSignUp() {
      let targetUrl = this.$route.path;
      sessionStorage.setItem("target", targetUrl);
      RouterUtils.changeRouteUrlTo("/get-started");
    }
  },
  beforeMount() {
    let groupSessionId = this.$route.params.id;
    this.customerModel.groupSessionId = groupSessionId;
    this.readModel.groupSessionId = groupSessionId;
    StoreUtils.dispatch("groupSession/readByGroupSessionId", this.readModel);
    StoreUtils.dispatch(
      "groupSession/readEnrolledClassCustomers",
      this.customerModel
    );
  }
};
</script>

<style scoped>
.skeleton-load {
  animation: skeleton-loading 1s linear infinite alternate;
  border-color: rgba(3, 28, 67, 0.1);
  border-radius: 8px;
  height: 40px;
  color: #031c43;
}
.class-action-btn-container {
  display: flex;
  gap: 8px;
  width: 50%;
  justify-content: flex-end;
}

.div-block-250-alt {
  width: 100%;
  padding: 0;
}

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 93%);
  }
  100% {
    background-color: hsl(200, 20%, 98%);
  }
}
@media only screen and (max-width: 541px) {
  .table-image-icon {
    display: none;
  }
  .w-col {
    padding-left: 0;
    padding-right: 0;
  }
  .div-block-255 {
    display: block;
    padding-top: 0;
  }
  .div-block-57 {
    width: 100%;
  }
  .text-block-49 {
    font-size: 22px;
  }
  .div-block-250 {
    padding: 100px 0;
  }
  .class-action-btn-container {
    margin-top: 15px;
    width: 100%;
    justify-content: flex-start;
  }
  .cell-text-small {
    /*text-overflow:ellipsis;*/
    overflow: hidden;
    /*white-space: nowrap;*/
    /*width: 200px;*/
    /*color: red;*/
  }
}
</style>
